import styled from 'styled-components';

import { Container, Dialog } from '@material-ui/core';

export const StyledContainer = styled(Container)`
  padding: 20px;

  .speedDial {
    position: absolute;
    bottom: 24px;
    right: 16px;
  }
`;

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    margin: 10px;

    .MuiDialogTitle-root {
      padding: 0px 0px 0px 15px;
    }
  }
  .container {
    display: flex;
    flex-wrap: wrap;
  }
  .content {
    color: green !important;
  }
`;

export const NewTagDialog = styled(Dialog)`
  .MuiDialog-paper {
    margin: 10px;
    width: 600xp;
    .MuiDialogTitle-root {
      padding: 0px 0px 0px 15px;
    }
  }
  .container {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const Main = styled.main`
  flex-grow: 1;
  height: 100vh;

  .container {
    padding-top: 32px;
    padding-bottom: 32px;
  }

  .test {
    margin-bottom: 10px;
  }

  .pageTitle {
    font-size: 26px;
    font-weight: bold;
    line-height: 30px;
    color: #1c1c1c;
    margin-top: 16px;
  }

  .membersContainer {
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    margin-top: 24px;
    padding-left: 130px;
    padding-right: 130px;
    justify-content: space-between;
  }
`;

export const StyledList = styled.ul`
  padding-left: 40px;
`;
